var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { style: _vm.cardStyle, attrs: { bordered: false } },
            [
              _c(
                "div",
                { staticClass: "table-page-search-wrapper" },
                [
                  _c(
                    "a-form",
                    {
                      attrs: { layout: "inline" },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.searchQuery.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "a-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 5, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "客户形态",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c(
                                    "a-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        placeholder: "全部形态",
                                        allowClear: "",
                                      },
                                      on: { change: _vm.searchQuery },
                                      model: {
                                        value: _vm.queryParam.customerType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryParam,
                                            "customerType",
                                            $$v
                                          )
                                        },
                                        expression: "queryParam.customerType",
                                      },
                                    },
                                    _vm._l(_vm.typeOptions, function (t) {
                                      return _c(
                                        "a-select-option",
                                        {
                                          key: t.value,
                                          attrs: { value: t.value },
                                        },
                                        [_vm._v(_vm._s(t.label))]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "客户名称",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c("a-input", {
                                    attrs: {
                                      placeholder: "请输入客户名称查询",
                                    },
                                    model: {
                                      value: _vm.queryParam.search,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.queryParam, "search", $$v)
                                      },
                                      expression: "queryParam.search",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "table-page-search-submitButtons",
                              staticStyle: {
                                float: "left",
                                overflow: "hidden",
                              },
                            },
                            [
                              _c(
                                "a-col",
                                { attrs: { md: 10, sm: 24 } },
                                [
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.searchQuery },
                                    },
                                    [_vm._v("查询")]
                                  ),
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: { "margin-left": "8px" },
                                      on: { click: _vm.searchReset },
                                    },
                                    [_vm._v("重置")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "table-operator",
                  staticStyle: { "margin-bottom": "16px" },
                },
                [
                  _vm.btnEnableList.indexOf(1) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { type: "primary", icon: "plus" },
                          on: { click: _vm.handleAdd },
                        },
                        [_vm._v("新增客户信用")]
                      )
                    : _vm._e(),
                  _c(
                    "span",
                    { staticStyle: { "margin-left": "8px", color: "#999" } },
                    [
                      _vm._v(
                        "信用体系为提示性管控：客户下单/生成订单时返回信用提示，不拦截业务。"
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "section",
                [
                  _c("a-table", {
                    ref: "table",
                    attrs: {
                      size: "middle",
                      bordered: "",
                      rowKey: "id",
                      columns: _vm.columns,
                      dataSource: _vm.dataSource,
                      pagination: false,
                      scroll: _vm.scroll,
                      loading: _vm.loading,
                    },
                    on: { change: _vm.handleTableChange },
                    scopedSlots: _vm._u([
                      {
                        key: "settle",
                        fn: function (text, record) {
                          return [
                            _c("a-tag", { attrs: { color: "blue" } }, [
                              _vm._v(_vm._s(record.settleTypeName)),
                            ]),
                            Number(record.creditLimit) > 0
                              ? _c(
                                  "span",
                                  { staticStyle: { "margin-left": "4px" } },
                                  [_vm._v("额度 " + _vm._s(record.creditLimit))]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                      {
                        key: "debt",
                        fn: function (text, record) {
                          return [
                            _c(
                              "span",
                              {
                                style:
                                  Number(record.debt) > 0
                                    ? "color: #f5222d"
                                    : "",
                              },
                              [_vm._v(_vm._s(record.debt))]
                            ),
                          ]
                        },
                      },
                      {
                        key: "action",
                        fn: function (text, record) {
                          return _c(
                            "span",
                            {},
                            [
                              _vm.btnEnableList.indexOf(1) > -1
                                ? [
                                    _c(
                                      "a",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleEdit(record)
                                          },
                                        },
                                      },
                                      [_vm._v("编辑")]
                                    ),
                                    _c(
                                      "a-popconfirm",
                                      {
                                        attrs: {
                                          title: "确定删除该客户的信用配置吗?",
                                        },
                                        on: {
                                          confirm: () =>
                                            _vm.handleDelete(record),
                                        },
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticStyle: {
                                              "margin-left": "8px",
                                            },
                                          },
                                          [_vm._v("删除")]
                                        ),
                                      ]
                                    ),
                                  ]
                                : _c("span", [_vm._v("-")]),
                            ],
                            2
                          )
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("a-pagination", {
                staticStyle: { "margin-top": "16px", "text-align": "right" },
                attrs: {
                  current: _vm.ipagination.current,
                  pageSize: _vm.ipagination.pageSize,
                  total: _vm.ipagination.total,
                },
                on: {
                  change: _vm.paginationChange,
                  showSizeChange: _vm.paginationShowSizeChange,
                },
              }),
              _c(
                "a-modal",
                {
                  attrs: {
                    title: _vm.modalTitle,
                    visible: _vm.modalVisible,
                    confirmLoading: _vm.modalLoading,
                    maskClosable: false,
                  },
                  on: {
                    ok: _vm.handleOk,
                    cancel: function ($event) {
                      _vm.modalVisible = false
                    },
                  },
                },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "客户形态",
                        labelCol: { span: 6 },
                        wrapperCol: { span: 15 },
                      },
                    },
                    [
                      _c(
                        "a-select",
                        {
                          staticStyle: { width: "100%" },
                          on: { change: _vm.onTypeChange },
                          model: {
                            value: _vm.form.customerType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "customerType", $$v)
                            },
                            expression: "form.customerType",
                          },
                        },
                        _vm._l(_vm.typeOptions, function (t) {
                          return _c(
                            "a-select-option",
                            { key: t.value, attrs: { value: t.value } },
                            [_vm._v(_vm._s(t.label))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "客户",
                        labelCol: { span: 6 },
                        wrapperCol: { span: 15 },
                      },
                    },
                    [
                      _c(
                        "a-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            showSearch: "",
                            optionFilterProp: "children",
                            placeholder: "请选择客户",
                          },
                          model: {
                            value: _vm.form.customerRef,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "customerRef", $$v)
                            },
                            expression: "form.customerRef",
                          },
                        },
                        _vm._l(_vm.customerOptions, function (c) {
                          return _c(
                            "a-select-option",
                            { key: c.id, attrs: { value: c.id } },
                            [_vm._v(_vm._s(c.name))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "结算方式",
                        labelCol: { span: 6 },
                        wrapperCol: { span: 15 },
                      },
                    },
                    [
                      _c(
                        "a-select",
                        {
                          staticStyle: { width: "100%" },
                          model: {
                            value: _vm.form.settleType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "settleType", $$v)
                            },
                            expression: "form.settleType",
                          },
                        },
                        _vm._l(_vm.settleOptions, function (s) {
                          return _c(
                            "a-select-option",
                            { key: s.value, attrs: { value: s.value } },
                            [_vm._v(_vm._s(s.label))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.form.settleType === "HOLD_N"
                    ? _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "压单数N",
                            labelCol: { span: 6 },
                            wrapperCol: { span: 15 },
                          },
                        },
                        [
                          _c("a-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              min: 1,
                              max: 99,
                              placeholder: "手里保留N单货款，第N+1单结第1单",
                            },
                            model: {
                              value: _vm.form.holdN,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "holdN", $$v)
                              },
                              expression: "form.holdN",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.settleType === "MONTHLY"
                    ? _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "对账日",
                            labelCol: { span: 6 },
                            wrapperCol: { span: 15 },
                          },
                        },
                        [
                          _c("a-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              min: 1,
                              max: 31,
                              placeholder: "每月几号对账回款（1-31）",
                            },
                            model: {
                              value: _vm.form.settleDays,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "settleDays", $$v)
                              },
                              expression: "form.settleDays",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "授信额度",
                        labelCol: { span: 6 },
                        wrapperCol: { span: 15 },
                      },
                    },
                    [
                      _c("a-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          min: 0,
                          precision: 2,
                          placeholder: "0=不启用额度管控；欠款超额度时提示",
                        },
                        model: {
                          value: _vm.form.creditLimit,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "creditLimit", $$v)
                          },
                          expression: "form.creditLimit",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "备注",
                        labelCol: { span: 6 },
                        wrapperCol: { span: 15 },
                      },
                    },
                    [
                      _c("a-textarea", {
                        attrs: { rows: 2, placeholder: "合同约定等备注信息" },
                        model: {
                          value: _vm.form.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "remark", $$v)
                          },
                          expression: "form.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }